import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
const columns = [
  {
    dataField: 'srNo',
    text: 'Sr No',
    editable: false,
    sort: true,
  },
  {
    dataField: 'title',
    text: 'Name',
    sort: true,
  },
  {
    dataField: 'createdAt',
    text: 'Created At',
    editable: false,
    sort: true,
  },
  {
    dataField: 'updatedAt',
    text: 'Updated At',
    editable: false,
    sort: true,
  },
];
export const LanguagesList = (props) => {
  const handleCellChange = (prevVal, currentVal, row) => {
    props.onUpdate(row.id, { title: currentVal });
  };

  return (
    <div className='table-responsive'>
      <BootstrapTable
        keyField='srNo'
        data={props.data || []}
        columns={columns}
        cellEdit={cellEditFactory({
          mode: 'dbclick',
          afterSaveCell: handleCellChange,
        })}
      />
    </div>
  );
};
